module.exports = __webpack_public_path__ + "media/images/btn-arrow-left-40b9199361a2d1319a1e904cfb842ba9.svg";